export default {
    meta: {
        title: 'Location供应商服务规则协议',
        isShowHeader: false,
    },
};
